let isProd = true

if (typeof window !== 'undefined') {
    isProd = window.location.hostname.includes('chessclub.com')
}

export { isProd }
